<template>
  <div v-if="$store.state.page.type == 'orbi'" class="dni-footer">
    <div>
      <div id="support" class="footer-links">
        <el-link href="http://www.netgear.com/support/product/RBR760.aspx" target="_blank">
        <b>{{ $t("help_and_support") }}</b>
        </el-link>
        <help-links class="footer-links" />
      </div>
      <div id="search">
        <b> {{ $t("search_help") }}</b>
        <search-form class="footer-search" />
      </div>
    </div>
  </div>
</template>
<script>
import HelpLinks from "@/components/header/helpLinks";
import SearchForm from "@/components/header/searchForm";
export default {
  components: { HelpLinks, SearchForm },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.dni-footer {
  position: absolute;
  left: 0 - $leftMenuWidth - $leftMenuToLeft;
  right: 0;
  height: $footerHeight;
  bottom: 1 - $footerHeight;
  background-color: #fff;
  padding: 0 20px;
  color: #fff;
  line-height: $footerHeight;
  z-index: $footerBarZIndex;
  overflow: hidden;
  #support {
    margin: 0 10px;
    float: left;
  }
  b {
    font-weight: bold;
  }
  .footer-links {
    padding-left: 10px;
    display: inline-block;
    font-size: 11px;
    .el-link {
      margin: 0 3px 0 0;
      color: #fff;
      letter-spacing: 0.1px;
      text-align: left;
    }
    .el-link:not(:last-child)::after,
    .el-link.is-underline:not(:last-child):hover:after {
      content: "|";
      margin-left: 3px;
      position: relative;
      border-bottom: 0 none;
      height: auto;
      bottom: unset;
    }
    .el-link.is-underline:last-child:hover:after {
      display: none;
    }
    .el-link.el-link--default:hover {
      color: #fff;
    }
  }
  #search {
    position: absolute;
    right: 30px;
    b {
      padding-right: 10px;
    }
    .footer-search {
      display: unset;
      width: auto;
      height: auto;
      float: right;
      .el-input {
        width: 130px;
        line-height: 26px;
        .el-input__inner {
          padding: 0 5px;
        }
      }
      .el-button {
        min-width: 39px;
        border: 1px solid #ddd !important;
        border-radius: 10px !important;
        background: #fff;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        margin: 8px 5px;
        padding: 0 5px;
      }
    }
  }
}
.dni-footer > div {
  background: url("/static/orbi/footer.png");
  background-size: 100% 100%;
  -moz-background-size: 100% 100%; /* 老版本的 Firefox */
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.single-main {
  .dni-footer {
    bottom: 0;
  }
}
</style>
